import Promise from 'promise-polyfill';
import 'es6-map-shim';
import subscribeManager, {unSubscribe as unsub} from './service-register'
import NoticePopup from './popup-subscribe';
import LoginState from './login-watcher'
import {getJson} from './request'
import {create as crateCookie, read as readCookie} from './cookie'
import track from './window-ga'
import SubscribeCategory from './subscribe-category'

let isPopupShowOnce = false;
let trackCategory = 'notification-push-article';

if (!window.Promise) {
	window.Promise = Promise;
}


class NotificationFlowRegister {

	constructor(subscribeManager) {
		this.subscribeManager = subscribeManager;
		this.categoryMainName = '';
		this.isTimeForShow = false;
		this.isServiceInit = false;
		this.isServiceRegisted = false;
		this.isSubscribedCategory = false;
		this.categoryMain = 0;
		this.categorySub = 0;
		this.contentId = 0;
		this.onestopInstance = null;
		this.userInfo = {};
		this.stateChangeCallback = [];
		this.popup = new NoticePopup();
		this.popup.hide();
		//this.onClickSubscribePopup = () => {};
		this.popup.onSubscribeClicked(() => {
			this.onClickSubscribePopup.bind(this)();
		});

		this.popup.onCloseClicked(() => {
			crateCookie(this.getPreventPopupCookieName(), 1, 60*60*24);
		});
		//this.subscribeManager.init()
	}

	init() {
		return this.initService();
	}

	getPreventPopupCookieName() {
		return `notification-popup-article-${this.categoryMain}`
	}

	onClickSubscribePopup() {
		track(trackCategory, 'subscribe-flow', 'clicked');
		//track(trackCategory, 'subscribe-click-prop-is-login', this.isLogin ? 'T' : 'F');
		//track(trackCategory, 'subscribe-click-prop-is-subcate', this.isSubscribedCategory ? 'T' : 'F');
		return new Promise((resolve, reject) => {
			this.isUserLogin().then((isLogin) => {
				if (isLogin) {
					track(trackCategory, 'subscribe-flow', 'already-login');
					this.initService().then((isRegistered) => {
						//console.log(isRegistered);
						track(trackCategory, 'subscribe-flow', 'already-login-init');
						return this.registerToken();
					}).then(() => {
						track(trackCategory, 'subscribe-flow', 'already-login-register');
						return SubscribeCategory.subscribe(this.categoryMain);
					}).then((response) => {
						track(trackCategory, 'subscribe-flow', 'already-login-subscribe');
						this.popup.hide();
						alert('เรียบร้อย! คุณได้ติดตามบทความหมวดนี้แล้ว เราจะเตือนคุณเมื่อมีบทความใหม่ๆมานะ')
						return resolve(response)
						//this.popup.hide();
					}).catch((ex) => {
						track(trackCategory, 'subscribe-flow-fail-exception-l', ex);
						return reject(ex)
					})
				} else {
					track(trackCategory, 'subscribe-flow', 'not-login');
					this.onestopInstance.start('login', ((status, info) => {
						if(!status) {
							if(typeof info !== 'undefined' && typeof info.cause !== 'undefined') {
								return track(trackCategory, 'subscribe-flow', 'not-login-abort');
							}
						}
						track(trackCategory, 'subscribe-flow', 'not-login-logged');
						this.initService().then((isRegistered) => {
							track(trackCategory, 'subscribe-flow', 'not-login-init');
							return this.registerToken();
						}).then(() => {
							track(trackCategory, 'subscribe-flow', 'not-login-register');
							return SubscribeCategory.subscribe(this.categoryMain);
						}).then((response) => {
							track(trackCategory, 'subscribe-flow', 'not-login-subscribed');
							this.popup.hide();
							alert('เรียบร้อย! คุณได้ติดตามบทความหมวดนี้แล้ว เราจะเตือนคุณเมื่อมีบทความใหม่ๆมานะ')
							return resolve(response)
						}).catch((ex) => {
							track(trackCategory, 'subscribe-flow-fail-exception-n', ex);
							return reject(ex)
						})
					}).bind(this))
				}
			})
		})
	}

	/**
	 *
	 * @returns Promise
	 */
	requestLogin(title) {
		return new Promise((resolve, reject) => {
			this.onestopInstance.start(title, (info) => {
				this.setLoginState = true;
				this.stateChange();
				resolve(true, info);
			}, () => {
				resolve(false);
			});
			/*this.onestopInstance.onModalClose(() => {
			 reject();
			 })*/
		})
	}

	/**
	 *
	 * @returns Promise
	 */
	isUserLogin() {
		return new Promise((resolve, reject) => {
			this.onestopInstance.checkLoginState((status, info) => {
				//console.log('check login status', status, info);
				return resolve(status, info);
			})
		})
	}

	/**
	 *
	 * @returns Promise
	 */
	initService() {
		//console.log('init service')
		return new Promise((resolve, reject) => {
			if (this.isServiceInit) return resolve(this.isServiceRegisted);

			//console.log('this.subscribeManager.init() called')

			this.subscribeManager.init().then(isServiceRegistered => {
				//console.log('inited')
				this.isServiceInit = true;
				this.isServiceRegisted = isServiceRegistered;
				this.stateChange();
				return resolve(isServiceRegistered)
			}).catch(error => {
				//console.log(error)
				this.isServiceInit = false;
				return reject(error)
			});
		});
	}

	registerToken() {
		return new Promise((resolve, reject) => {
			/*if (this.isServiceRegisted) {
				this.subscribeManager.updateToken();
				return resolve({
					'status': true,
					'message': 'user already registered.'
				});
			}*/
			this.subscribeManager.subscribe().then(jsonResponse => {
				this.isServiceRegisted = true;
				this.stateChange();
				resolve(jsonResponse);
			}).catch(error => reject(error))
		})
	}

	unRegisterToken() {
		return new Promise((resolve, reject) => {
			this.subscribeManager.unsubscribe().then(jsonResponse => {
				this.isServiceRegisted = false;
				this.stateChange();
				resolve(jsonResponse);
			}).catch(error => reject(error))
		})
	}

	isTokenRegistered() {
		return this.isServiceInit && this.isServiceRegisted;
	}

	isPopupShouldShow() {
		//alert('this.isTimeForShow' + (this.isTimeForShow ? ' T' : ' F'))
		/*console.log('ispopupshouldshow',
			'this.isTokenRegistered()', this.isTokenRegistered(),
		'this.isLogin', this.isLogin,
		'this.isSubscribedCategory', this.isSubscribedCategory,
		'this.isPreventShowPopupByCookie != 1', this.isPreventShowPopupByCookie != 1,
		'this.isTimeForShow', this.isTimeForShow,
		'overall', !(
			this.isTokenRegistered()
			&& this.isLogin
			&& this.isSubscribedCategory)
			&& this.isPreventShowPopupByCookie != 1
			&& this.isTimeForShow)*/
		return !(
			this.isTokenRegistered()
			&& this.isLogin
			&& this.isSubscribedCategory)
			&& this.isPreventShowPopupByCookie != 1
			&& this.isTimeForShow
	}

	renderPopup() {
		//console.log('render popup')
		if (this.isPopupShouldShow()) {
			if(!isPopupShowOnce) {
				isPopupShowOnce = true;
				track(trackCategory, 'popup-visible');
				track(trackCategory, 'subscribe-click-prop-is-login', this.isLogin ? 'T' : 'F');
				track(trackCategory, 'subscribe-click-prop-is-subcate', this.isSubscribedCategory ? 'T' : 'F');
			}
			this.popup.show();
		} else {
			this.popup.hide();
		}
	}

	setLoginState(isLogin, info) {
		this.isLogin = isLogin;
		this.userInfo = info;
		this.stateChange();
	}

	setIsSubscribeCategory(isSubscribed) {
		this.isSubscribedCategory = isSubscribed;
		this.stateChange();
	}

	setCategoryMain(categoryMain) {
		this.categoryMain = categoryMain;
		this.isPreventShowPopupByCookie = readCookie(this.getPreventPopupCookieName());
		this.stateChange();
	}

	setCategoryMainName(name){
		this.categoryMainName = name;
		this.popup.setCategoryName(this.categoryMainName);
	}

	setCategorySub(categorySub) {
		this.categorySub = categorySub;
		this.stateChange();
	}

	setContentId(contentId) {
		this.contentId = contentId;
		this.stateChange();
	}

	setOnestopInstance(onestop) {
		this.onestopInstance = onestop;
	}

	setIsTimeForShow(shouldShow) {
		this.isTimeForShow = shouldShow;
		this.stateChange();
	}

	onStateChange(callback) {
		this.stateChangeCallback.push(callback);
	}

	stateChange() {

		//console.log('state change', this.stateChangeCallback);
		//alert('state change '/* + typeof this.stateChangeCallback*/)
		this.stateChangeCallback.forEach(callback => {
			callback(this);
		});
	}

}

function startPushNotificationFlow({
	isSubscribedCategory = false,
	categoryMain = 0,
	categorySub = 0,
	contentId = 0,
	oneStop = null,
	categoryMainName = 'บทความ'
}) {

	//console.log('aaaaa');

	//alert('navigator.serviceWorker ' +  (typeof navigator.serviceWorker === 'undefined' ? 'T' : 'F'));

	//alert('navigator.serviceWorker '); return;

	let subscribeCategory = new SubscribeCategory();

	let notificationRegister = new NotificationFlowRegister(subscribeManager);
	notificationRegister.setOnestopInstance(oneStop);
	notificationRegister.setCategoryMain(categoryMain);
	notificationRegister.setCategorySub(categorySub);
	notificationRegister.setContentId(contentId);
	notificationRegister.setCategoryMainName(categoryMainName);
	notificationRegister.setIsSubscribeCategory(isSubscribedCategory);

	//console.log('setTimeout')
	setTimeout(() => {
		//console.log('show time!')
		//alert('show time!')
		notificationRegister.setIsTimeForShow(true)
	}, 6000);

	let loginState = new LoginState();
	loginState.onLogin(info => {
		notificationRegister.setLoginState(true, info);
		SubscribeCategory.isUserSubscribeCategory(categoryMain, categorySub).then((isSubscribe) => {
			//console.log('aaa', isSubscribe);
			notificationRegister.setIsSubscribeCategory(isSubscribe)
		});
	});
	loginState.onLogout(() => {
		notificationRegister.setLoginState(false, {});
		notificationRegister.setIsSubscribeCategory(false)
	});

	notificationRegister.init().then(() => {
		notificationRegister.renderPopup();

		//console.log('init notificationRegister')

		notificationRegister.onStateChange((manager) => {
			//console.log('on state change');
			manager.renderPopup();
		})
	}).catch((error) => { console.log(error) })


	window.subscribe = (callback) => {
		notificationRegister.onClickSubscribePopup()
			.then(response => callback(true, response))
			.catch(error => callback(false, error));
	}

}


window.startPushNotificationFlow = startPushNotificationFlow;
window.unsub = unsub;



/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/notification-subscribe.js
 **/